var _rect, _rect2, _rect3, _rect4, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPassport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 64,
    viewBox: "0 0 46 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.011,
    width: 36.201,
    height: 56,
    rx: 4,
    transform: "rotate(-7.956 1 6.01)",
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.01,
    width: 44,
    height: 56,
    rx: 4,
    fill: "#fff",
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.284,
    y: 49.056,
    width: 14.25,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.284,
    y: 43.874,
    width: 19.432,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.001,
    cy: 26.938,
    r: 7.569,
    stroke: "#2C2D2E",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA0NiA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iNi4wMTA3NCIgd2lkdGg9IjM2LjIwMSIgaGVpZ2h0PSI1NiIgcng9IjQiIHRyYW5zZm9ybT0icm90YXRlKC03Ljk1NTcgMSA2LjAxMDc0KSIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iMSIgeT0iNi4wMTAyNSIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjU2IiByeD0iNCIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxyZWN0IHg9IjE2LjI4NDIiIHk9IjQ5LjA1NjQiIHdpZHRoPSIxNC4yNSIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzJDMkQyRSIvPgo8cmVjdCB4PSIxMy4yODQyIiB5PSI0My44NzQ1IiB3aWR0aD0iMTkuNDMxOCIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzJDMkQyRSIvPgo8Y2lyY2xlIGN4PSIyMy4wMDA2IiBjeT0iMjYuOTM3NiIgcj0iNy41Njg5OCIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgPassport as ReactComponent };